module.exports = __webpack_public_path__ + "img/album08_12.ab890f09.jpg";